import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.detail');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import toastr from 'toastr';
import { ActivatedRoute, Router } from '@angular/router';

interface Researcher {
    id: string;
    auth_id: string | null;
    org_id: string | null;
    kr_name: string | null;
    en_name: string | null;
    email: string | null;
    updated: string | null;
    like_count: number;
    name: string | null;
}

interface Product {
    id: string;
    pub_year: number | null; r
    auth_list: string;
    [key: string]: any;
}

@Component({
    selector: 'wiz-page-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.detail/view.scss */
/* src/app/page.detail/view.scss: no such file or directory */`],
})
export class PageDetailComponent implements OnInit {
    public data!: SendData;
    public researcher: Researcher | null = null;
    public products: Product[] = [];

    public avgData: Record<number, number> = {};

    public period: any;
    public years: number[] = [];

    public org_id = '';

    public category = "analysis";
    public categories = [
        { title: '성과 통계', id: 'analysis' },
        { title: '성과물', id: 'product' },
        { title: '연구자 네트워크', id: 'network' }
    ];

    public category_map: any = {
        '성과 통계': 'analysis',
        '성과물': 'product',
        '연구자 네트워크': 'network'
    };

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public async ngOnInit() {
        if (WizRoute.segment.category)
            this.category = WizRoute.segment.category;
        this.load();
        await this.service.render();
    }

    public async load() {
        const auth_id = WizRoute.segment.id;
        try {
            await this.service.init();
            const { code, data } = await wiz.call("get_researcher", { 'auth_id': auth_id });
            this.data = data;
            this.period = data.period;
            this.researcher = data.researcher;
            await this.service.render();
        } catch {
            toastr.error('데이터를 불러오지 못했습니다.');
            this.researcher = null;
            this.products = [];
            this.avgData = {};
        }
    }

    public onYearsChange(years: number[]) {
        this.years = years ?? [];

        if (this.years.length > 0) {
            this.period = {
                start: this.years[0],
                end: this.years[this.years.length - 1]
            };
        } else {
            this.period = { start: null, end: null };
        }
        this.service.render();
    }

    public async changeC(t) {
        this.category = t.id;
        await this.service.href(`/detail/${WizRoute.segment.id}/${t.id}`);
        await this.service.render();
    }

    public formatOrgs(orgs: string[] | null): string {
        if (!orgs || orgs.length === 0) return '-';
        return orgs.join(', ');
    }

}

export default PageDetailComponent;